/**
 * Animates PDP fit indicator bars from data-fit-value.
 */
(() => {
  /**
   * @param {HTMLElement} root
   */
  const applyFitIndicator = (root) => {
    const fill = root.querySelector('[data-fit-fill]');
    const rawValue = root.dataset.fitValue;

    if (!fill || rawValue == null || rawValue === '') return;

    const percentage = Math.min(Math.max(parseFloat(rawValue), 0), 100);
    if (Number.isNaN(percentage)) return;

    fill.style.width = `${percentage}%`;
  };

  const init = () => {
    document.querySelectorAll('[data-fit-indicator]').forEach(applyFitIndicator);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();
